<template>
  <div>
    <!-- 顶部 -->
    <div>


      <!-- //筛选 -->
      <div class="ht-40 minht-40">
        <h3 class="primary-bg tzgg-title dis-ib hs3" :style="ind==i ? IndStyle : ''" v-for="(item,i) in pici" :key="i" @click="piciqiehuan(item.batchid,i)">{{item.batchname}}</h3>
      </div>

      <!-- 搜索框 -->
      <div>
        <div class="searchs">
          <span>搜索最新职位：</span>
          <input type="text" class="searchText" v-model="qSearch">
          <input type="button" value="搜索" class="searchBtn fs-18 bdn" @click="jobSearch(piciId,null,qSearch)">
        </div>
      </div>

    </div>



    <!-- 尾部 -->
    <div class="bottoms">
    <!-- 筛选区 -->
    <div class="sx">
      <ul>
        <li class="lis" @click="jobSearch(piciId,null,null)">全部</li>
        <li v-for="item in leftList" :key="item.id" class="lis" @click="jobSearch(item.batchid,item.departmentid,null)">
          <a-tooltip>
            <template slot="title">
              {{item.deptname}}
            </template>
            <span class="tzTitle">{{item.deptname}}</span>
          </a-tooltip>
        </li>
      </ul>
    </div>
    <!-- 表格 -->
    <div>
    <div class="topcell"></div>

     <a-table :columns="columns" :pagination="pagination" :data-source="list">

        <a slot="JOBNAME" slot-scope="text,record">
          <span @click="$router.push({path:'/gw',query: {jobID:record.JOBID}})">{{ record.JOBNAME }}</span>
        </a>

        <span slot="cz" slot-scope="text,record">
          <div class="df sqsc">
            <button class="sqbtn" @click="sq(record)">申请</button>
            <button class="scbtn" @click="sc(record)">收藏</button>
          </div>

        </span>
    </a-table>
    </div>

    </div>






    <xxjl :studyVisible.sync="studyVisible"></xxjl>

    <ssjl :JobVisible.sync="JobVisible"></ssjl>

    <jtcy :FMVisible.sync="FMVisible"></jtcy>

    <gwbb :visible.sync="visible" :gwbbData="gwbbData" :ksplace="ksplace"></gwbb>



  </div>
</template>



<script>
import xxjl from '../compos/xxjl.vue'
import ssjl from '../compos/ssjl.vue'
import jtcy from '../compos/jtcy.vue'
import gwbb from '../compos/gwbb.vue'

export default {
    components:{
      xxjl,ssjl,jtcy,gwbb
    },

    data() {
    return {
      labelCol: { span: 9 },
      wrapperCol: { span: 10 },

        //获取已投递简历的数据
        jldata:[],

        //头像信息
        a01109:'',

        //职位查询参数
        qSearch:'',

        //储存当前人员id
        A00:'',

       //批次列表
      pici:[

      ],
      //当前是点击了哪一个批次iD
      piciId:'',


       //左侧栏数据
      leftList:[],
      //表格数据
      list:[],
      // 头
      columns:[
  {
    title: '职位名称',
    dataIndex: 'JOBNAME',
    key: 'JOBNAME',
    slots: { title: 'JOBNAME' },
    scopedSlots: { customRender: 'JOBNAME' },
  },
  {
    title: '专业要求',
    dataIndex: 'JOBREQUIRE_PROFESSION',
    key: 'JOBREQUIRE_PROFESSION',
  },
  {
    title: '学历要求',
    dataIndex: 'JOBREQUIRE_DEGREE',
    key: 'JOBREQUIRE_DEGREE',
  },
  {
    title: '用人单位',
    key: 'DEPTNAME',
    dataIndex: 'DEPTNAME',
  },
  {
    title: '需求人数',
    dataIndex: 'JOBREQUIRE_NUMBER',
    key: 'JOBREQUIRE_NUMBER',
  },
  {
    title: '发布日期',
    dataIndex: 'PUBTIME',
    key: 'PUBTIME',
  },
  {
    title: '操作',
    key: 'cz',
    dataIndex: 'cz',
    scopedSlots: { customRender: 'cz' },
  },
      ],


      //对话框显示隐藏
      visible:false,
      //学习经历的对话框
      studyVisible:false,
      ///工作经历对话框
      JobVisible:false,
      //家庭对话框
      FMVisible:false,
      //对话框第几步
      step:1,
      //学习经历表格数据
      studyListDate:[
        {
          id:1,
          studyStartTime:'2021-05-07',
          studyLastTime:'2021-05-07',
          education:'本科',
          academic:'博士',
          universities:'北大',
          college:1,
          Major:'软件工程',
          Types:'1',
          system:'aaa'
        },
      ],
      //学习经历表格头
      studyColumns:[
        {
          title: '入学时间',
          dataIndex: 'studyStartTime',
          key: 'studyStartTime',
        },
        {
          title: '毕业时间',
          dataIndex: 'studyLastTime',
          key: 'studyLastTime',
        },
        {
          title: '学历',
          dataIndex: 'education',
          key: 'education',
        },
        {
          title: '学位',
          dataIndex: 'academic',
          key: 'academic',
        },
        {
          title: '院校',
          dataIndex: 'universities',
          key: 'universities',
        },
        {
          title: '学院',
          dataIndex: 'college',
          key: 'college',
        },
        {
          title: '所学专业',
          dataIndex: 'Major',
          key: 'Major',
        },
        {
          title: '教育类型',
          dataIndex: 'Types ',
          key: 'Types ',
        },
        {
          title: '学制',
          dataIndex: 'system',
          key: 'system',
        },
        {
          title: '操作',
          dataIndex: 'cz',
          key: 'cz',
          scopedSlots: { customRender: 'cz' },
        }
      ],
      //实习或工作经历表格头
      JobColums:[
        {
          title: '起始时间',
          dataIndex: 'times',
          key: 'times',
        },
        {
          title: '截止日期',
          dataIndex: 'lasttimes',
          key: 'lasttimes',
        },
        {
          title: '企业或公司名称',
          dataIndex: 'companyName',
          key: 'companyName',
        },
        {
          title: '从事工作或担任职位',
          dataIndex: 'Job',
          key: 'Job',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
        ],
      //实习或工作经历表格数据
      JobListDate:[
         {
          id:1,
          times:'2000.1.2',
          lasttimes:'2012.1.2',
          companyName:'阿里巴巴',
          Job:'前端工程师',
        },
      ],
      //家庭情况表头
      FamilyColums:[
         {
          title: '姓名',
          dataIndex: 'name',
          key: 'name',
        },
        {
          title: '与本人关系',
          dataIndex: 'relationship',
          key: 'relationship',
        },
        {
          title: '民族',
          dataIndex: 'nation',
          key: 'nation',
        },
        {
          title: '政治面貌',
          dataIndex: 'Political',
          key: 'Political',
        },
        {
          title: '联系电话',
          dataIndex: 'phone',
          key: 'phone',
        },
        {
          title: '工作单位',
          dataIndex: 'Workunit',
          key: 'Workunit',
        },
        {
          title: '出生日期',
          dataIndex: 'Birthday',
          key: 'Birthday',
        },
        {
          title: '操作',
          dataIndex: 'todo',
          key: 'todo',
          scopedSlots: { customRender: 'todo' },
        }
      ],
      // 家庭情况表格数据
      FamilyListDate:[
          {
          id:1,
          name:'2000.1.2',
          relationship:'2012.1.2',
          nation:'汉族',
          Political:'共产党员',
          phone:'前端工程师',
          Workunit:'前端工程师',
          Birthday:'前端工程师',
        },
      ],





      // 传给对话框的数据
      gwbbData:{},

      ksplace:[],

      //应届毕业生信息表单数据
      StudentInfo:{
        location:'',
        city:'city',
        egLevel:'',
        type: [],
        dxs:[],
        wzs:[],
        xsgbInfo:'',
        txLocation:'',
        PostalCode:'',
        teacher:'',
        teacherPhone:'',
        desc:''
      },

      //社会招聘信息表单数据
      SocialInfo:{
        Household:'',
        archives:'',
        JobBegin:'',
        WorkUnit:'',
        WorkUnitTime:'',
        posts:'',
        postTime:''
      },

      //控制显示保存还是修改数据
      baocun1:true,
      baocun2:true,
      baocun3:true,

      //设置深红色的样式
      IndStyle: {backgroundColor: '#F32D26'},
      ind: null,
      pagination: {
        total: 0, // 总数
        showTotal: total => `共 ${total} 条`,
      }
    }
  },

  methods:{


    // 点击了收藏按钮
    sc(record){
      console.log(record.JOBID);
      this.post({
        url:'addCollectionRecord',
        data:{
          A00:sessionStorage.getItem('aabb'),
          jobId:record.JOBID
        }
      },(res)=>{
        console.log(res);
        if(res.message=="此职位已经被收藏"){
          return alert("此职位已经被收藏")
        }else if(res.code==200){
          alert('职位收藏成功')
        }else if(res.code==401){
          alert('请先登录')
        }
        // if(res.message=="此职位已经被收藏"){
        //   return this.$message.warning("此职位已经被收藏")
        // }else if(res.code==200){
        //   this.$message.success('职位收藏成功')
        // }else if(res.code==401){
        //   this.$message.error('请先登录')
        // }
      })
    },
    //点击了申请
    sq(r){
      console.log(r);
      if(!sessionStorage.getItem('BDSOFT-TOKEN')) return this.$message.warning('请先登录')

      if(!this.a01109) return this.$message.error('请先上传照片')

      // var issq = this.jldata.some(i => {
      //   return i.JOBID===r.JOBID
      // });
      // if(issq) return this.$message.error('您已经申请过该职位了')

      // var ispcsq = this.jldata.some(i => {
      //   return i.BATCHID===r.BATCHID
      // });
      // if(ispcsq) return this.$message.error('您已超过当前批次申报数，无法再申报')

      this.post({
        url: 'allowApplyNum',
        data: {
          A00: sessionStorage.getItem('aabb'),
          BATCHID: r.BATCHID,
          JOBID: r.JOBID,
        }
      },(res)=>{
        console.log(res);
        if(res.message=="正常填报！"){
          this.gwbbData=r

          this.get({
            url:'getPlaceid',
            data:{
              batchid:r.BATCHID
            }
          },(res)=>{
            console.log(res);
            console.log(999);
            if(res.code==200){
              this.ksplace=res.data
            }
          })

          this.visible=true
        }else if(res.message=="已申请过该职位，不能重复申请！"){
          this.$message.error(res.message)
        } else{
          this.$message.error(res.message)
        }
      })
    },




     //查询发布批次
    getChooseBatch(){
      this.get({
        url:'getChooseBatch',
      },(res)=>{
        console.log(res);
        console.log(999);
        if(res.code===200){
          this.piciId=res.data.list[0].batchid
          this.pici=res.data.list
          this.getCurrentBantchDeplist(res.data.list[0].batchid)
        }
      })
    },
     // 查询发布批次下的单位信息
    getCurrentBantchDeplist(i){
      this.post({
        url:'getCurrentBantchDeplist',
        data:{
          batchid:i
        }
      },(res)=>{
        if(res.code===200){
          this.leftList=res.data
          this.jobSearch(i,null,null)

        }
      })
    },
    //根据单位信息查询职位信息
    jobSearch(batchid,bumenid,q){
      this.post({
        url:'jobSearch',
        data:{
          batchid:batchid,
          depid:bumenid,
          jobname:q,
          pageNum:1,
          pageSize:10
        }
      },(res)=>{
        console.log(res);
        if(res.code===200){
          this.list=res.data.list
          this.pagination.total = res.data.total
        }
      })
    },

    //点击切换了批次
    piciqiehuan(i,ind){
      this.ind=ind
      this.piciId=i
      this.getCurrentBantchDeplist(i)
    },

    //获取已申请过的列表
    deliveryProgress(){
      this.post({
          url: 'deliveryProgress',
      }, (res) => {
        console.log(555);
        console.log(res);
        this.jldata=res.data
      })
    },

    //获取个人简历的照片信息
    //获取个人简历信息
    getBasicInfo(){
      this.post({
        url:'getBasicInfo',
        data:{
          a00:sessionStorage.getItem('aabb'),
        }
      },(res)=>{
        this.a01109 = res.data.zdyxa0106

      })
    },



  },

  created(){
      this.getChooseBatch()
      this.deliveryProgress()
      this.getBasicInfo()
      // this.getCurrentBantchDeplist(1)
  },

}
</script>


<style scoped>
.colorRed{
  background-color:#CC0000 ;
  height: 36px;
  width: 992px;
  font-size: 16px;
  color: #fff;
  line-height: 36px;
  text-align: center;
}
.searchs{
  margin-top: 20px;
  margin-bottom: 18px;
  text-align: center;
}
.searchText{
  width: 400px;
  height: 30px;
  border: 1px solid #E60012;
  margin-left: 17px;
}
.searchBtn{
  width: 78px;
  height: 34px;
  color: #fff;
  margin-left: 16px;
  background-color: #E98737;
  border-radius: 2px;
}

.bottoms{
  display: flex;
}

.sx{
  margin-right: 8px;
}

li{
  list-style: none;
  width: 240px;
  height: 36px;
  background-color: #CC0000;
  color: #fff;
  margin-bottom: 1px;
  text-align: center;
  line-height: 36px;

}
.fl{
  display: flex;
}

.topcell{
  width: 100%;
  height: 6px;
  background: #990000;
}

.sqbtn{
 background-color: #E98737;
 border: none;
 color: #fff;
 width: 43px;
 height: 22px;
 margin-right: 6px;
 font-weight: 400;
}

.sqbtn:hover{
  cursor:pointer
}

.scbtn{
  background-color: #CC0000;
  border: none;
  color: #fff;
  width: 43px;
  height: 22px;
  font-weight: 400;
}

.scbtn:hover{
  cursor:pointer
}

.lis:hover{
  background-color: red;
}

.messages{
  overflow: hidden;
  background-color: #e3efff;
  width: 100%;
}

.ryjbxxTitle{
  width: 128px;
  height: 30px;
  background: #CC0000;
  border-radius: 15px;
  text-align: center;
  line-height: 30px;
  color: #FEFEFE;
  margin: 0 auto;
  font-size: 16px;
}

.remarks{
  font-size: 14px;
  color: red;
  font-weight: bold;
  text-align: center;
  background-color: #E3EFFF;
  border-bottom:1px solid #C1D7F9;
  padding: 15px;
}

.tzgg-title {
  border-radius: 5px 5px 0px 0px;
  height: 39px;
  line-height: 39px;
  text-align: center;
  width: 19%;
  padding-left: 20px;
  padding-right: 20px;
  -webkit-border-radius: 5px 5px 0px 0px;
  -moz-border-radius: 5px 5px 0px 0px;
  color: #fff;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 10px;
  cursor: pointer;
}
.hs3{
  margin-bottom: -5px;
}
.minht-40{
  border-bottom: 2px solid #CC0000!important;
  overflow: hidden;
}
.adds{
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 20px 0;
  font-size: 16px;
}

.adds div:hover{
  cursor: pointer;
}

.adds button:hover{
  cursor: pointer;
}

.adds div{
  width: 25px;
  height: 25px;
  background-color: #c00000;
  border-radius: 50%;
  text-align: center;
  line-height: 25px;
  color: white;
  font-weight: blod;
  margin-right: 5px;
}

.adds button{
  background-color: #E3EFFF;
  color: #c00000;
  border:none;
  font-size: 16px;
}

.dialogFooter{
  background-color: #e3efff;
  border: 1px solid #c1d7f9;
  display: flex;
  justify-content: center;
  align-items: center;
}

.btnStyle1{
  width: 84px;
  height: 36px;
  background-color: #f1a338;
  font-size: 16px;
  line-height: 36px;
  text-align: center;
  color: #fff;
  border: none;
  border-radius: 3px;
  margin: 10px 5px;
}

.btnStyle1:hover{
  cursor:pointer;
}





/deep/ .ant-table-tbody > tr > td {
  padding: 5px;
  height: 38px;
}

/* 这里设置了表头颜色，不知道什么没有生效 */

/deep/ .ant-table-thead{
  background-color: #FFE5E5!important;
}

/deep/ .ant-table-pagination.ant-pagination {
    float: left;
}

/deep/ .ant-table-tbody{
  background-color: #fff;
}

/deep/ .ant-table-body td{
  width: 14.2%;
  text-overflow:ellipsis;
  text-align: center;
}

/deep/ .ant-modal-content{
  width: 696px!important;
  height: 803px!important;
}

/deep/ .ant-btn-primary{
  color: #1890ff;
  background-color: white;
  border-color: white;
  box-shadow: none;
}

/deep/ .ant-table-row {
  padding: 5px 0!important;
}

/deep/ th{
  text-align: center!important;
}

/deep/ .ant-form-item-control{
  text-align: center;
}

/deep/ .ant-input{
  /* width: 600px!important; */
}

/deep/ .ant-modal-content th{
  text-align: center!important;
  padding: 0px 10px !important;
}

/deep/ .ant-modal-content td{
  text-align: center!important;
  padding: 0px 0px !important;
}

/deep/ .ant-col{
  height: 40px!important;
  font-size: 16px!important;
}

/deep/ .ant-table-body {
    width: 742px!important;
}
.tzTitle{
  float:left;
  width:100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  padding: 0 5px;
}
</style>



// WEBPACK FOOTER //
// src/views/zkzw/pages/index.vue